document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".tab");
  const buttons = document.querySelectorAll(".carousel-menu div");

  buttons.forEach(button => {
    button.addEventListener("click", function() {
      const tabId = this.getAttribute("id");
      
      tabs.forEach(tab => {
        if (tab.id === tabId) {
          tab.style.display = "block";
        } else {
          tab.style.display = "none";
        }
      });
    });
  });
  
  // Default display the first tab
  document.querySelector("#good-to-know").style.display = "block";
});
